import Red from "../../components/Red";
import Yellow from "../../components/Yellow";
import Blue from "../../components/Blue";
export const TypeRGB = {
  a: "ساختمان مسکونی فروخته شده و قیمت گذاری شده",
  b: "ساختمان مسکونی فروخته شده و قیمت گذاری نشده",
  c: "ساختمان مسکونی قیمت گذاری نشده",
  d: "ساختمان مسکونی قیمت گذاری شده",
  e: "ساختمان مسکونی پیش خرید شده",
  f: "ساختمان مسکونی قفل غیر قابل فروش",
  g: "ساختمان مسکونی دارای محدودیت معامله",
  h: "ساختمان تجاری فروخته شده و قیمت گذاری شده",
  i: "ساختمان تجاری فروخته شده و قیمت گذاری نشده",
  j: "ساختمان تجاری قیمت گذاری نشده",
  k: "ساختمان تجاری قیمت گذاری شده",
  l: "ساختمان تجاری پیش خرید شده",
  m: "ساختمان تجاری قفل غیر قابل فروش",
  n: "ساختمان تجاری دارای محدودیت معامله",
  o: "ساختمان آموزشی فروخته شده و قیمت گذاری شده",
  p: "ساختمان آموزشی فروخته شده و قیمت گذاری نشده",
  q: "ساختمان آموزشی قیمت گذاری نشده",
  r: "ساختمان آموزشی قیمت گذاری شده",
  s: "محدوده فرهنگی فروخته شده و قیمت گذاری شده",
  t: "محدوده فرهنگی فروخته شده و قیمت گذاری نشده",
  u: "محدوده فرهنگی قیمت گذاری نشده",
  v: "محدوده فرهنگی قیمت گذاری شده",
  w: "محدوده انتظامی فروخته شده و قیمت گذاری شده",
  x: "محدوده انتظامی فروخته شده و قیمت گذاری نشده",
  y: "محدوده انتظامی قیمت گذاری نشده",
  z: "محدوده انتظامی قیمت گذاری شده",
  pa: "ساختمان پارکینگ فروخته شده و قیمت گذاری شده ",
  pb: "ساختمان پارکینگ فروخته شده و قیمت گذاری نشده",
  pc: "ساختمان پارکینگ قیمت گذاری نشده ",
  pd: "ساختمان پارکینگ قیمت گذاری شده ",
  me: "محدوده مذهبی فروخته شده و قیمت گذاری شده",
  mf: "محدوده مذهبی فروخته شده و قیمت گذاری نشده",
  mg: "محدوده مذهبی قیمت گذاری نشده",
  mh: "محدوده مذهبی قیمت گذاری شده",
  gi: "محدوده گردشگری فروخته شده و قیمت گذاری شده",
  gj: "محدوده گردشگری فروخته شده و قیمت گذاری نشده",
  gk: "محدوده گردشگری قیمت گذاری نشده",
  gl: "محدوده گردشگری قیمت گذاری شده",
  bm: "ساختمان بهداشتی فروخته شده و قیمت گذاری شده ",
  bn: "ساختمان بهداشتی فروخته شده و قیمت گذاری نشده",
  bo: "ساختمان بهداشتی قیمت گذاری نشده ",
  bp: "ساختمان بهداشتی قیمت گذاری شده ",
  nq: "محدوده نمایشگاه فروخته شده و قیمت گذاری شده",
  nr: "محدوده نمایشگاه فروخته شده و قیمت گذاری نشده",
  ns: "محدوده نمایشگاه قیمت گذاری نشده",
  nt: "محدوده نمایشگاه قیمت گذاری شده",
  fu: "محدوده فضای سبز فروخته شده و قیمت گذاری شده",
  fv: "محدوده فضای سبز فروخته شده و قیمت گذاری نشده",
  fw: "محدوده فضای سبز  قیمت گذاری نشده",
  fx: "محدوده فضای سبز قیمت گذاری نشده",
  uu: "ساختمان آموزشی دارای محدودیت معامله",
  oo: "ساختمان آموزشی درحال ساخت",
  pp: "ساختمان آموزشی دارای بنا",
  tt: "ساختمان آموزشی قفل غیر قابل فروش",
  ss: "ساختمان آموزشی پیش خرید شده",
  ii: "ساختمان تجاری دارای بنا",
  hh: "ساختمان تجاری درحال ساخت",
  bb: "ساختمان مسکونی دارای بنا",
  aa: "ساختمان مسکونی درحال ساخت",
  cc: "ساختمان مسکونی دارای سلسله",
};
export const COMBINE_FEATURE = {
  a: "ساختمان مسکونی فروخته شده و قیمت گذاری شده",
  b: "ساختمان مسکونی فروخته شده و قیمت گذاری نشده",
  c: "ساختمان مسکونی قیمت گذاری نشده",
  d: "ساختمان مسکونی قیمت گذاری شده",
  e: "ساختمان مسکونی پیش خرید شده",
  f: "ساختمان مسکونی قفل غیر قابل فروش",
  g: "ساختمان مسکونی دارای محدودیت معامله",
  h: "ساختمان تجاری فروخته شده و قیمت گذاری شده",
  i: "ساختمان تجاری فروخته شده و قیمت گذاری نشده",
  j: "ساختمان تجاری قیمت گذاری نشده",
  k: "ساختمان تجاری قیمت گذاری شده",
  l: "ساختمان تجاری پیش خرید شده",
  m: "ساختمان تجاری قفل غیر قابل فروش",
  n: "ساختمان تجاری دارای محدودیت معامله",
  o: "ساختمان آموزشی فروخته شده و قیمت گذاری شده",
  p: "ساختمان آموزشی فروخته شده و قیمت گذاری نشده",
  q: "ساختمان آموزشی قیمت گذاری نشده",
  r: "ساختمان آموزشی قیمت گذاری شده",
  s: "محدوده فرهنگی فروخته شده و قیمت گذاری شده",
  t: "محدوده فرهنگی فروخته شده و قیمت گذاری نشده",
  u: "محدوده فرهنگی قیمت گذاری نشده",
  v: "محدوده فرهنگی قیمت گذاری شده",
  w: "محدوده انتظامی فروخته شده و قیمت گذاری شده",
  x: "محدوده انتظامی فروخته شده و قیمت گذاری نشده",
  y: "محدوده انتظامی قیمت گذاری نشده",
  z: "محدوده انتظامی قیمت گذاری شده",
  pa: "ساختمان پارکینگ فروخته شده و قیمت گذاری شده ",
  pb: "ساختمان پارکینگ فروخته شده و قیمت گذاری نشده",
  pc: "ساختمان پارکینگ قیمت گذاری نشده ",
  pd: "ساختمان پارکینگ قیمت گذاری شده ",
  me: "محدوده مذهبی فروخته شده و قیمت گذاری شده",
  mf: "محدوده مذهبی فروخته شده و قیمت گذاری نشده",
  mg: "محدوده مذهبی قیمت گذاری نشده",
  mh: "محدوده مذهبی قیمت گذاری شده",
  gi: "محدوده گردشگری فروخته شده و قیمت گذاری شده",
  gj: "محدوده گردشگری فروخته شده و قیمت گذاری نشده",
  gk: "محدوده گردشگری قیمت گذاری نشده",
  gl: "محدوده گردشگری قیمت گذاری شده",
  bm: "ساختمان بهداشتی فروخته شده و قیمت گذاری شده ",
  bn: "ساختمان بهداشتی فروخته شده و قیمت گذاری نشده",
  bo: "ساختمان بهداشتی قیمت گذاری نشده ",
  bp: "ساختمان بهداشتی قیمت گذاری شده ",
  nq: "محدوده نمایشگاه فروخته شده و قیمت گذاری شده",
  nr: "محدوده نمایشگاه فروخته شده و قیمت گذاری نشده",
  ns: "محدوده نمایشگاه قیمت گذاری نشده",
  nt: "محدوده نمایشگاه قیمت گذاری شده",
  fu: "محدوده فضای سبز فروخته شده و قیمت گذاری شده",
  fv: "محدوده فضای سبز فروخته شده و قیمت گذاری نشده",
  fw: "محدوده فضای سبز  قیمت گذاری نشده",
  fx: "محدوده فضای سبز قیمت گذاری نشده",
  uu: "ساختمان آموزشی دارای محدودیت معامله",
  oo: "ساختمان آموزشی درحال ساخت",
  pp: "ساختمان آموزشی دارای بنا",
  tt: "ساختمان آموزشی قفل غیر قابل فروش",
  ss: "ساختمان آموزشی پیش خرید شده",
  ii: "ساختمان تجاری دارای بنا",
  hh: "ساختمان تجاری درحال ساخت",
  bb: "ساختمان مسکونی دارای بنا",
  aa: "ساختمان مسکونی درحال ساخت",
  cc: "ساختمان مسکونی دارای سلسله",
};

export const RESIDENTIAL = {
  a: "ساختمان مسکونی فروخته شده و قیمت گذاری شده",
  b: "ساختمان مسکونی فروخته شده و قیمت گذاری نشده",
  c: "ساختمان مسکونی قیمت گذاری نشده",
  d: "ساختمان مسکونی قیمت گذاری شده",
  e: "ساختمان مسکونی پیش خرید شده",
  f: "ساختمان مسکونی قفل غیر قابل فروش",
  g: "ساختمان مسکونی دارای محدودیت معامله",
  bb: "ساختمان مسکونی دارای بنا",
  aa: "ساختمان مسکونی درحال ساخت",
  cc: "ساختمان مسکونی دارای سلسله",
};

export const COMMERCIAL = {
  h: "ساختمان تجاری فروخته شده و قیمت گذاری شده",
  i: "ساختمان تجاری فروخته شده و قیمت گذاری نشده",
  j: "ساختمان تجاری قیمت گذاری نشده",
  k: "ساختمان تجاری قیمت گذاری شده",
  l: "ساختمان تجاری پیش خرید شده",
  m: "ساختمان تجاری قفل غیر قابل فروش",
  n: "ساختمان تجاری دارای محدودیت معامله",
  ii: "ساختمان تجاری دارای بنا",
  hh: "ساختمان تجاری درحال ساخت",
};

export const EDUCATIONAL = {
  o: "ساختمان آموزشی فروخته شده و قیمت گذاری شده",
  p: "ساختمان آموزشی فروخته شده و قیمت گذاری نشده",
  q: "ساختمان آموزشی قیمت گذاری نشده",
  r: "ساختمان آموزشی قیمت گذاری شده",
  uu: "ساختمان آموزشی دارای محدودیت معامله",
  oo: "ساختمان آموزشی درحال ساخت",
  pp: "ساختمان آموزشی دارای بنا",
  tt: "ساختمان آموزشی قفل غیر قابل فروش",
  ss: "ساختمان آموزشی پیش خرید شده",
};

export default function FeatureType(karbari) {
  if (RESIDENTIAL[karbari]) {
    return "ساختمان مسکونی";
  }

  if (COMMERCIAL[karbari]) {
    return "ساختمان تجاری";
  }

  if (EDUCATIONAL[karbari]) {
    return "ساختمان آموزشی";
  }

  return "نامشخص";
}

export function FeatureColor(rgb) {
  if (RESIDENTIAL[rgb]) {
    return <Yellow />;
  }

  if (COMMERCIAL[rgb]) {
    return <Red />;
  }

  if (EDUCATIONAL[rgb]) {
    return <Blue />;
  }

  return false;
}

export function FeaturePrice(rgb) {
  if (RESIDENTIAL[rgb]) {
    return 10000;
  }

  if (COMMERCIAL[rgb]) {
    return 30000;
  }

  if (EDUCATIONAL[rgb]) {
    return 60000;
  }
}

export function FeatureSvg(rgb) {
  if (RESIDENTIAL[rgb]) {
    return "/successful/residential";
  }

  if (COMMERCIAL[rgb]) {
    return "/successful/commercial";
  }

  if (EDUCATIONAL[rgb]) {
    return "/successful/educational";
  }
}
